import { toStringValue } from "features/shared/lib/formatters";

import type { WindowCatalogItem } from "../model/types";
import type { WindowConfigFormState } from "./windowConfigFieldDefinitions";

import { findWindowCatalogItem } from "./windowConfigOptions";

export type PerformanceCatalogFormFields = Pick<
  WindowConfigFormState,
  "gValueDiffuseWindow" | "gValueDirectWindow" | "gValueWindow" | "uValue" | "windowInfiltration"
>;

const clearPerformanceCatalogFields = (): PerformanceCatalogFormFields => ({
  gValueDiffuseWindow: "",
  gValueDirectWindow: "",
  gValueWindow: "",
  uValue: "",
  windowInfiltration: "",
});

const mapWindowCatalogItemToFormFields = (
  item: Pick<
    WindowCatalogItem,
    "gValueDiffuseWindow" | "gValueDirectWindow" | "gValueWindow" | "uValue" | "windowInfiltration"
  >
): PerformanceCatalogFormFields => ({
  gValueDiffuseWindow: toStringValue(item.gValueDiffuseWindow),
  gValueDirectWindow: toStringValue(item.gValueDirectWindow),
  gValueWindow: toStringValue(item.gValueWindow),
  uValue: toStringValue(item.uValue),
  windowInfiltration: toStringValue(item.windowInfiltration),
});

export const applyWindowCatalogPrefill = (
  state: WindowConfigFormState,
  catalog: WindowCatalogItem[]
): WindowConfigFormState => {
  const catalogItem = findWindowCatalogItem<WindowCatalogItem>(catalog, state.windowTypeName, state.frameType);
  if (!catalogItem) {
    return { ...state, ...clearPerformanceCatalogFields() };
  }

  return { ...state, ...mapWindowCatalogItemToFormFields(catalogItem) };
};
